/* eslint-disable */
import { useState, useEffect, useContext, useMemo } from "react";
import React from "react";

// material react table
import { MaterialReactTable } from "material-react-table";
import { defaultTableConfig, withStrictFilter } from "Config/tableConfig";
import * as XLSX from "xlsx";
import { Link } from "react-router-dom";

import * as url from "urlhelpers/UrlHelper";
import { getData } from "utils/Gateway";

//import context
import { GlobalProvider } from "context/GlobalContext";

//import translation function for language translation
import { useTranslation } from "react-i18next";
import EditReserveTemplatePopup from "../Popup/EditReserveTemplatePopup";

const ReserveTemplateListBody = ({
  downloadExcel,
  search,
  setRecords,
  checkedRecordCount,
}) => {
  const {
    screenHeight,
    reloadReserveTemplateList,
    setReloadReserveTemplateList,
  } = useContext(GlobalProvider);

  const token = localStorage.getItem("token"); // token
  const { t } = useTranslation(); //for translation

  const [templateList, setTemplateList] = useState([]);
  const [responseReceived, setResponseReceived] = useState(false);
  const [reserveTemplateId, setReserveTemplateId] = useState(null);
  const [rowSelection, setRowSelection] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const getSelectedData = () => {
    const selectedIds = Object.keys(rowSelection).filter((key) => rowSelection[key]);
    return templateList.filter((item) => selectedIds.includes(item._id));
  };

  /* Excel export */
  const exportExcel = () => {
    const selectedData = getSelectedData();
    const exportData = selectedData.length > 0 ? selectedData : templateList;
    const ws = XLSX.utils.json_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, "ReserveTemplate.xlsx");
  };

  //function for get all reserve as select
  const getAllReserveTemplate = async (currentSearch = search) => {
    try {
      setIsLoading(true);
      let requestUrl =
        url.API_BASEURL +
        url.API_GET_ALL_EVENT_TEMPLATE_LIST +
        `?token=${token}`;

      if (currentSearch?.trim()) {
        requestUrl += `&globalsearch=${encodeURIComponent(currentSearch.trim())}`;
      }

      console.log("Get all reserve template url========>", requestUrl);

      const response = await getData(requestUrl);

      console.log("Get all reserve template response========>", response);

      if (response.status) {
        setTemplateList(response.data);
        setResponseReceived(true);
        setRecords(response.data.length);
      }
    } catch (error) {
      console.error(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  /* custom name cell html */
  const customNameHtml = ({ dataItem }) => {
    return (
      <div className="">
        <div className="d-flex align-items-center gap-2">
          <span>{dataItem.templatename} </span>
          <Link
            to="#editReservationTemplatePopup"
            data-bs-toggle="offcanvas"
            className="ml-auto edit_icon"
            onClick={() => {
              setReserveTemplateId(dataItem._id);
            }}
          >
            <span className="d-block material-symbols-outlined icon-md">
              edit
            </span>
          </Link>
        </div>
      </div>
    );
  };

  useEffect(() => {
    if (reloadReserveTemplateList) {
      getAllReserveTemplate();
      setReloadReserveTemplateList(false);
    }
  }, [reloadReserveTemplateList]);

  const afterCloseEditPopup = () => {
    getAllReserveTemplate();
  };

  useEffect(() => {
    getAllReserveTemplate();
  }, []);

  /* hook to hit downloadExcel function */
  useEffect(() => {
    downloadExcel && exportExcel();
  }, [downloadExcel]);

  /* set records when templateList changes */
  useEffect(() => {
    setRecords(templateList.length);
  }, [templateList]);

  /* sync selected count to parent */
  useEffect(() => {
    const selectedCount = Object.keys(rowSelection).filter((key) => rowSelection[key]).length;
    checkedRecordCount(selectedCount);
  }, [rowSelection, templateList]);

  const tableColumns = useMemo(
    () => withStrictFilter([
      {
        id: "templatename",
        accessorKey: "templatename",
        header: t("Template Name"),
        Cell: ({ row }) => customNameHtml({ dataItem: row.original }),
        size: 300,
      },
      {
        id: "activitycode",
        accessorKey: "activitycode",
        header: t("Activity Code"),
        size: 200,
      },
      {
        id: "activityname",
        accessorKey: "activityname",
        header: t("Activity Name"),
        size: 200,
      },
      {
        id: "activitytype",
        accessorKey: "activitytype",
        header: t("Activity type"),
        size: 200,
      },
      {
        id: "reservedate",
        accessorKey: "reservedate",
        header: t("Reserve Date"),
        size: 200,
      },
    ]),
    [t]
  );

  return (
    <div className="activity_table">
      <div className="table-responsive">
        <MaterialReactTable
          {...defaultTableConfig}
          enableGlobalFilter
          globalFilterFn="strictContains"
          columns={tableColumns}
          data={templateList}
          enableSorting
          enableGrouping
          enableColumnOrdering
          enableStickyHeader
          enableRowSelection
          onRowSelectionChange={setRowSelection}
          getRowId={(row) => row._id}
          state={{ rowSelection, isLoading }}
          renderLoadingOverlay={() => null}
          muiLinearProgressProps={{ sx: { display: "none" } }}
          muiCircularProgressProps={{ sx: { display: "none" } }}
          muiTableContainerProps={{ sx: { maxHeight: screenHeight } }}
          muiTableBodyRowProps={{ sx: { overflow: "visible" } }}
          muiTableBodyProps={{ sx: { overflow: "visible" } }}
        />
      </div>

      {/* ----- edit template popup ---- */}
      <EditReserveTemplatePopup
        reserveTemplateId={reserveTemplateId}
        setReserveTemplateId={setReserveTemplateId}
        afterCloseEditPopup={afterCloseEditPopup}
      />
    </div>
  );
};

export default ReserveTemplateListBody;
